<template>
	<div class="reset-container">
		<div class="reset-component">
			<img class="logo" src="@/assets/img/logo.png" alt="logo"/>
			<h1 class="reset-title">Reset password</h1>
			<p class="reset-subtitle">Set a new password for your account</p>
			<form class="form-reset">
				<v-row>
					<v-text-field
							dense
							hide-details
							v-model="password"
							@input="$v.password.$touch()"
							@blur="$v.password.$touch()"
							class="mb-6 mt-6"
							label="Password"
							placeholder="Enter Password"
							autocomplete="new-password"
							:error-messages="passwordErrors"
							type="password"
					></v-text-field>
				</v-row>
				<v-row>
					<v-text-field
							dense
							hide-details
							v-model.trim="$v.repeatPassword.$model"
							:error-messages="checkRepeatPass"
							label="Password Repeat"
							class="mb-8"
							type="password"
							placeholder="Confirm pasword"
					></v-text-field>
				</v-row>
				<v-row class="btn-holder">
					<v-btn
							:disabled="isValidPass"
							type="submit"
							class="btn-success"
							@click="submit"
					>submit
					</v-btn
					>
				</v-row>
			</form>
		</div>
	</div>
</template>
<!--<script>-->
<!--import { validationMixin } from "vuelidate";-->
<!--import {-->
<!--	sameAs,-->
<!--	minLength,-->
<!--} from "vuelidate/lib/validators";-->

<!--export default {-->
<!--	mixins: [ validationMixin ],-->

<!--	validations: {-->
<!--		password: {-->
<!--			minLength: minLength(6),-->
<!--		},-->
<!--		repeatPassword: {-->
<!--			sameAsPassword: sameAs("password"),-->
<!--		},-->
<!--	},-->
<!--	data() {-->
<!--		return {-->
<!--			password: "",-->
<!--			repeatPassword: "",-->
<!--			isActiveToken: false,-->
<!--		};-->
<!--	},-->
<!--	computed: {-->
<!--		email() {-->
<!--			return this.$route.query.email;-->
<!--		},-->
<!--		token() {-->
<!--			return this.$route.query.token;-->
<!--		},-->
<!--		checkRepeatPass() {-->
<!--			if (!this.$v.repeatPassword.sameAsPassword) {-->
<!--				return "Passwords must be identical.";-->
<!--			}-->
<!--			return "";-->

<!--		},-->
<!--		passwordErrors() {-->
<!--			const errors = [];-->
<!--			if (!this.$v.password.$error) return errors;-->
<!--			!this.$v.password.minLength &&-->
<!--			errors.push("Min lenghts password 6 chars");-->
<!--			return errors;-->
<!--		},-->
<!--		isValidPass() {-->
<!--			if (-->
<!--				!this.checkRepeatPass &&-->
<!--					this.repeatPassword &&-->
<!--					this.password &&-->
<!--					!this.passwordErrors[0]-->
<!--			)-->
<!--				return false;-->
<!--			return true;-->
<!--		},-->
<!--		checkPass() {-->
<!--			if (this.password) {-->
<!--				if (!this.$v.password.$error && !this.checkRepeatPass) return true;-->
<!--				return false;-->
<!--			}-->
<!--			return true;-->

<!--		},-->
<!--	},-->
<!--	async created() {-->
<!--		this.$store.dispatch("actionPreloader", true);-->
<!--		await this.$store-->
<!--			.dispatch("isActivUpdate", this.$route.fullPath.split("?")[1])-->
<!--			.then((value) => {-->
<!--				this.$store.dispatch("actionPreloader", false);-->
<!--				if (value.status === false) {-->
<!--					this.isActiveToken = false;-->
<!--					this.$store.dispatch("setAlert", {-->
<!--						type: "error",-->
<!--						message: "Your token is not active",-->
<!--					});-->
<!--					this.$router.push("/auth");-->
<!--				} else {-->
<!--					this.isActiveToken = true;-->
<!--				}-->
<!--			});-->
<!--	},-->
<!--	methods: {-->
<!--		async submit(e) {-->
<!--			e.preventDefault();-->
<!--			this.$store.dispatch("actionPreloader", true);-->
<!--			const req = Object.assign({}, this.$route.query);-->
<!--			req.password = this.password;-->
<!--			await this.$store.dispatch("updatePass", req).then((value) => {-->
<!--				this.$store.dispatch("actionPreloader", false);-->
<!--				if (value.status === true) {-->
<!--					this.$store.dispatch("setAlert", {-->
<!--						type: "success",-->
<!--						message: "Your password has been changed",-->
<!--					});-->
<!--					this.$router.push("/auth");-->
<!--				}-->
<!--			});-->
<!--		},-->
<!--	},-->
<!--};-->
<!--</script>-->

<script>
import { validationMixin } from "vuelidate";
import { sameAs, minLength } from "vuelidate/lib/validators";

export default {
	mixins: [ validationMixin ],

	validations: {
		password: { minLength: minLength(6) },
		repeatPassword: { sameAsPassword: sameAs("password") },
	},

	data() {
		return {
			password: "",
			repeatPassword: "",
			isActiveToken: false,
		};
	},

	computed: {
		// ⬇️ Тепер беремо з params АБО з query
		token() {
			return this.$route.params.token || this.$route.query.token || "";
		},
		email() {
			// email може прийти як %40 — декодуємо для відображення,
			// але для запитів заново ЕНКОДИМО
			const q = this.$route.query.email || "";
			return q ? decodeURIComponent(q) : "";
		},

		checkRepeatPass() {
			if (!this.$v.repeatPassword.sameAsPassword) {
				return "Passwords must be identical.";
			}
			return "";
		},
		passwordErrors() {
			const errors = [];
			if (!this.$v.password.$error) return errors;
			!this.$v.password.minLength && errors.push("Min lenghts password 6 chars");
			return errors;
		},
		isValidPass() {
			if (!this.checkRepeatPass && this.repeatPassword && this.password && !this.passwordErrors[0]) {
				return false;
			}
			return true;
		},
		checkPass() {
			if (this.password) {
				if (!this.$v.password.$error && !this.checkRepeatPass) return true;
				return false;
			}
			return true;
		},
	},

	async created() {
		// ✅ Перевіряємо наявність обов'язкових параметрів
		if (!this.token || !this.email) {
			this.$store.dispatch("setAlert", {
				type: "error",
				message: "Invalid password reset link. Please request a new one.",
			});
			this.$router.push("/auth");
			return;
		}

		this.$store.dispatch("actionPreloader", true);

		// ✅ Формуємо те саме, що ти раніше передавав через split("?")[1]:
		// token=...&email=...
		const queryString =
				`token=${ encodeURIComponent(this.token) }` +
				`&email=${ encodeURIComponent(this.email) }`;

		try {
			const value = await this.$store.dispatch("isActivUpdate", queryString);
			this.$store.dispatch("actionPreloader", false);

			if (value.status === false) {
				this.isActiveToken = false;
				this.$store.dispatch("setAlert", {
					type: "error",
					message: "Your token is not active",
				});
				this.$router.push("/auth");
			} else {
				this.isActiveToken = true;
			}
		} catch (e) {
			this.$store.dispatch("actionPreloader", false);
			this.$store.dispatch("setAlert", {
				type: "error",
				message: "Something went wrong. Try again later.",
			});
			this.$router.push("/auth");
		}
	},

	methods: {
		async submit(e) {
			e.preventDefault();
			if (this.isValidPass) return;

			this.$store.dispatch("actionPreloader", true);

			// бек очікує token та email — відправимо як і раніше, але явно
			const req = {
				token: this.token,
				email: this.email,
				password: this.password,
			};

			const value = await this.$store.dispatch("updatePass", req);
			this.$store.dispatch("actionPreloader", false);

			if (value?.status === true) {
				this.$store.dispatch("setAlert", {
					type: "success",
					message: "Your password has been changed",
				});
				this.$router.push("/auth");
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@import "./reset.component";
</style>
